import { SearchBox, SearchProvider } from '@elastic/react-search-ui'
import { SearchDriverOptions } from '@elastic/search-ui'
import React from 'react'
import { CommonSearchProps } from 'src/shared/types/entities/search-interface'
import { SearchAutocompleteView } from './search-autocomplete-view'
import { SearchInputView } from './search-input-view'
import { SearchWrapperUi } from './ui'

interface SearchProps extends CommonSearchProps {
  config: SearchDriverOptions
  searchPath?: string
  showDropdown?: boolean
  isPreviewMode?: boolean
}

export const CommonSearch = ({
  config,
  item,
  itemTitle,
  itemText,
  seeMore,
  dropdown,
  input,
  searchPath = '/search',
  showDropdown = false,
  isPreviewMode = false,
  ...props
}: SearchProps) => {
  const handleSubmit = (searchTerm: string) => {
    if (!isPreviewMode) {
      const params = new URLSearchParams({ query: searchTerm })
      const url = `${searchPath}?${params.toString()}`
      window.location.assign(url)
    }
  }

  return (
    <SearchProvider config={config}>
      <SearchWrapperUi
        padding={props.padding}
        mobilePadding={props.mobilePadding}
      >
        <SearchBox
          autocompleteMinimumCharacters={3}
          debounceLength={showDropdown ? 0 : 200}
          inputView={props =>
            SearchInputView({
              ...props,
              input,
              showDropdown,
              isPreviewMode,
              onSubmit: handleSubmit,
              autocompleteProps: {
                item,
                itemTitle,
                itemText,
                seeMore,
                dropdown,
              },
            })
          }
          autocompleteView={props =>
            SearchAutocompleteView({
              ...props,
              item,
              itemTitle,
              itemText,
              seeMore,
              dropdown,
              minChars: 3,
              isPreviewMode,
            })
          }
          onSubmit={handleSubmit}
          autocompleteSuggestions={false}
          autocompleteResults={true}
        />
      </SearchWrapperUi>
    </SearchProvider>
  )
}
